import styled from 'styled-components';
import { colors } from 'components/Theme';
import { asRem } from 'utils';

export default styled.div`
  background-color: ${colors.pink.c500};
  flex: 1;
  display: flex;
  align-items: center;

  .container {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: ${asRem(260)};
    padding: ${asRem(48)} 0;
  }

  .mime-elements-headline-3 {
    color: ${colors.white.c500};
  }

  .indifferent-img {
    width: 100%;
  }

  .description {
    color: ${colors.white.c500};
  }

  .app-badges {
    justify-content: space-between;
  }
`;
